export default {
    user: {
      token: localStorage.getItem('TOKEN'),
      data: {},
    },

    route: {
      targetRoute: '',
    }
}